import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { fetchAllCategories } from "../api/categories";
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const IMAGE_BASE_URL =
  process.env.REACT_APP_API_IMAGE_URL || "http://localhost:3000";

const Categories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryData = await fetchAllCategories();
        setCategories(categoryData);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <SEO {...seoDefaults.categories} />
      <section className="min-h-screen px-6 pt-32 pb-20 bg-black text-white relative overflow-hidden">
        {/* Background blur effects */}
        <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-purple-900/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-cyan-900/15 rounded-full blur-3xl animate-pulse" />

        <div className="relative z-10 max-w-7xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-12">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
              Explore Our Collections
            </span>
          </h2>

          {categories.length === 0 ? (
            <p className="text-center text-gray-400">
              No categories available.
            </p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {categories.map((category) => (
                <Link
                  to={`/products/category/${category.slug}`}
                  key={category._id}
                  className="group bg-gray-900/80 border border-purple-700 rounded-2xl overflow-hidden shadow-xl hover:scale-105 transition-all transform backdrop-blur-lg hover:border-pink-600"
                >
                  <img
                    src={`${IMAGE_BASE_URL}${category.image}`}
                    alt={category.name}
                    className="w-full h-56 object-cover border-b border-purple-700 group-hover:border-pink-600"
                  />
                  <div className="p-5 text-center">
                    <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600 group-hover:from-pink-500 group-hover:to-purple-600 tracking-tight mb-2">
                      {category.name}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Categories;
